"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./SectionHeader.css");
var SectionHeader = (function (_super) {
    __extends(SectionHeader, _super);
    function SectionHeader(props) {
        return _super.call(this, props) || this;
    }
    SectionHeader.prototype.render = function () {
        var _a = this.props, text = _a.text, size = _a.size, color = _a.color, wrapMode = _a.wrapMode, id = _a.id, role = _a.role;
        var cssClasses = generateClasses();
        function generateClasses() {
            var cssClasses = ['p-sectionheader'];
            cssClasses.push(constructClass(size, 'p-f-sz'));
            cssClasses.push(constructClass(color, 'p-t'));
            if (wrapMode == 'Ellipsis') {
                cssClasses.push('p-t-wr-el');
            }
            else if (wrapMode == 'ForcedWrap' || text.indexOf(' ') < 0) {
                cssClasses.push('p-t-wr-fw');
            }
            return cssClasses.join(' ');
        }
        var attrs = {};
        if (this.props.tag != null)
            attrs["data-tag"] = this.props.tag;
        if (id != null)
            attrs["id"] = id;
        attrs["title"] = text;
        if (this.props.role != '')
            attrs["role"] = this.props.role;
        function customizeEnums(en) {
            var cases = {
                'H5': 'lg',
                'H4': 'xl',
                'H3': '2x',
                'H2': '3x',
                'H1': '4x',
                'Primary': 'Primary50',
                'Secondary': 'Secondary50',
                'Success': 'Success50',
                'Warning': 'Warning50',
                'Error': 'Error50',
                'Info': 'Info50',
            };
            return cases[en]
                ? cases[en].toLowerCase()
                : en.toLowerCase();
        }
        function constructClass(prop, prefix) {
            if (prop && prop !== 'None') {
                var customProp = customizeEnums(prop);
                return prefix + "-" + customProp;
            }
        }
        var _sectionHeader = null;
        switch (size) {
            case "H1": {
                _sectionHeader = (React.createElement("h1", __assign({ className: cssClasses }, attrs), text));
                break;
            }
            case "H2": {
                _sectionHeader = (React.createElement("h2", __assign({ className: cssClasses }, attrs), text));
                break;
            }
            case "H3": {
                _sectionHeader = (React.createElement("h3", __assign({ className: cssClasses }, attrs), text));
                break;
            }
            case "H4": {
                _sectionHeader = (React.createElement("h4", __assign({ className: cssClasses }, attrs), text));
                break;
            }
            case "H5": {
                _sectionHeader = (React.createElement("h5", __assign({ className: cssClasses }, attrs), text));
                break;
            }
        }
        return _sectionHeader;
    };
    return SectionHeader;
}(React.Component));
SectionHeader.defaultProps = {
    text: '',
    size: 'H1',
    color: 'Default',
    wrapMode: 'None',
    tag: null,
    id: null,
    role: ''
};
exports.SectionHeader = SectionHeader;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['common-controls'])
        csod.engine.controls['common-controls'] = {};
    csod.engine.controls['common-controls']['SectionHeader'] = SectionHeader;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["SectionHeader"] = [];


//////////////////
// WEBPACK FOOTER
// ../player-common-controls/controls/SectionHeader/index.js
// module id = 156
// module chunks = 0